import React, {useMemo, useState} from 'react';
import styled from "styled-components";
import LlmHeader from "./llmHeader";
import LlmCompare from "./llmCompare";
import KoreanAd from "../ad/KoreanAd";
import LlmMasterContent from "./llmMasterContent";
import useChampionFunc from "../../common/hooks/useChampionFunc";
import useGetChampionBuild from "../../common/hooks/llm/useGetChampionBuild";
import {useHistory, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";

const LLMHowTo = styled.div`
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
`;
const Wrapper = styled.div``;
const AdWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
`;
const LLMMaster = styled.div`
`;

const LlmContent = () => {
    const currentLang = useSelector((state) => state.translation.lang);
    const {getChampionByName, getChampion} = useChampionFunc();
    const location = useLocation();
    const history = useHistory();
    const search = new URLSearchParams(location.search)
    const [inputPickChampion, setInputPickChampion] = useState(() => {
        const champion = search.get('champion')
        if (champion) {
            return getChampion(champion).champion_name
        }
        return getChampion('61').champion_name
    });
    const [inputAgainstChampion, setInputAgainstChampion] = useState(() => {
        const champion = search.get('enemy')
        if (champion) {
            return getChampion(champion).champion_name
        }
        return getChampion('7').champion_name
    });
    const [position, setPosition] = useState(() => {
        const position = search.get('position')
        if (position) {
            return position
        }
        return ""
    });


    const [pickChampion, setPickChampion] = useState(() => {
        const champion = search.get('champion')
        if (champion) {
            return champion
        }
        return getChampionByName(inputPickChampion).champion_id
    });
    const [againstChampion, setAgainstChampion] = useState(() => {
        const champion = search.get('enemy')
        if (champion) {
            return champion
        }
        return getChampionByName(inputAgainstChampion).champion_id
    });


    const currentPickChampion = useMemo(() => getChampion(pickChampion), [pickChampion, getChampion]);
    const currentAgainstChampion = useMemo(() => getChampion(againstChampion), [againstChampion, getChampion]);


    const onChangeInputPickChampion = (e) => {
        if (typeof e?.target?.value !== 'undefined') {
            setInputPickChampion(e.target.value.trim())
            const champion = getChampionByName(e.target.value.trim())?.champion_id
            if (champion) {
                setPickChampion(champion)
            }
            history.replace({
                search: ""
            })
        }
    }

    const onChangeInputAgainstChampion = (e) => {
        if (typeof e?.target?.value !== 'undefined') {
            setInputAgainstChampion(e.target.value.trim())
            const champion = getChampionByName(e.target.value.trim())?.champion_id
            if (champion) {
                setAgainstChampion(champion)
            }
            history.replace({
                search: ""
            })
        }
    }

    const onChangePickChampion = (value) => {
        setPickChampion(value)
    }

    const onChangeAgainstChampion = (value) => {
        setAgainstChampion(value)
    }

    const getChampionBuild = useGetChampionBuild({champion_id: pickChampion})
    const getAgainstChampionBuild = useGetChampionBuild({champion_id: againstChampion})

    const pickChampionBuild = useMemo(() => {
        try {
            return getChampionBuild.data.find((data) => data?.lane?.toLowerCase() === position.toLowerCase())
        } catch (e) {
            return {}
        }
    }, [position, getChampionBuild.data]);
    const againstChampionBuild = useMemo(() => {
        try {
            return getAgainstChampionBuild.data.find((data) => data?.lane?.toLowerCase() === position.toLowerCase())
        } catch (e) {
            return {}
        }
    }, [position, getAgainstChampionBuild.data]);

    return (
        <Wrapper>
            <LLMHowTo>
                <LlmHeader
                    currentPickChampion={currentPickChampion}
                    pickChampionBuild={pickChampionBuild}
                />
                <LlmCompare
                    position={position}
                    setPosition={setPosition}
                    inputPickChampion={inputPickChampion}
                    inputAgainstChampion={inputAgainstChampion}
                    onChangeInputPickChampion={onChangeInputPickChampion}
                    onChangeInputAgainstChampion={onChangeInputAgainstChampion}
                    onChangePickChampion={onChangePickChampion}
                    onChangeAgainstChampion={onChangeAgainstChampion}
                    againstChampion={currentAgainstChampion}
                    pickChampion={currentPickChampion}
                    pickChampionBuild={pickChampionBuild}
                    againstChampionBuild={againstChampionBuild}

                />
            </LLMHowTo>
            <AdWrapper>
                <KoreanAd/>
            </AdWrapper>
            <LLMMaster>
                <LlmMasterContent
                    key={`pickChamp${currentPickChampion?.champion_id}Against${currentAgainstChampion?.champion_id}`}
                    pickChampion={currentPickChampion?.champion_id}
                    againstChampion={currentAgainstChampion?.champion_id}
                />
            </LLMMaster>
        </Wrapper>
    );
};


export default LlmContent;